var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
var SortPopupBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  ", "\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 999;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  "], ["\n    margin-top: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  "])), theme.spacing.one, theme.border.radius, theme.colors.utility.white, theme.shadows.low);
});
export default SortPopupBox;
var templateObject_1, templateObject_2;
